import http from "./httpService";
import { getApiUrl } from "../config";

const apiEndpoint = getApiUrl() + "/RemoteFile";

export async function getRemoteFile(owner: string, name: string): Promise<RemoteConfig> {
    let resp = await http.get<RemoteConfig>(`${apiEndpoint}?owner=${owner}&name=${name}`);
    return resp.data;
}

export async function saveRemoteFile(file: File, owner: string, name: string) {
    const form = new FormData();
    form.append("file", file);
    const response = await http.post<any>(`${apiEndpoint}?owner=${owner}&name=${name}`, form);
    return response.data;

};

export async function listRemoteFile(owner: string, name: string) {
    const form = new FormData();
    const response = await http.get<RemoteFile[]>(`${apiEndpoint}/list?owner=${owner}&name=${name}`);
    return response.data;

};

